export default __webpack_public_path__ + "static/media/rainbowl-logo-sm.5469cebb.png";